import React from 'react';
import { useNavigate } from 'react-router-dom';


export default function PageNotFound() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/'); // Navigates to homepage
    };

    const handleGoBack = () => {
        navigate(-1); // Goes back to the previous page
    };


    const styles = {
        gradientBg: {
            background: 'linear-gradient(135deg, #fef7ed 0%, #fef3c7 100%)',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            padding: '0',
            margin: '0',
            boxSizing: 'border-box',
        },
        number404: {
            fontSize: '8rem',
            fontWeight: 'bold',
            background: 'linear-gradient(90deg, #d97706 0%, #ea580c 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            opacity: '0.2',
            lineHeight: '1',
        },
        searchIcon: {
            width: '100px',
            height: '100px',
            background: 'linear-gradient(135deg, #d97706 0%, #ea580c 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '3rem',
            color: 'white',
            animation: 'pulse 2s infinite',
        },
        primaryBtn: {
            background: 'linear-gradient(90deg, #d97706 0%, #ea580c 100%)',
            border: 'none',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        secondaryBtn: {
            background: 'white',
            border: '2px solid #d97706',
            color: '#d97706',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        },
        footerBg: {
            background: 'linear-gradient(90deg, #d97706 0%, #ea580c 100%)',
            color: 'white',
            padding: '20px 0',
        },
    };

    return (
        <>
            <div style={styles.gradientBg}>
                <style>{`
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          .primary-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2) !important;
          }
          .secondary-btn:hover {
            background-color: #fef7ed !important;
            transform: translateY(-1px);
          }
        `}</style>

                <main style={{ flex: 1 }} className="d-flex align-items-center justify-content-center">
                    <div className="container text-center">
                        {/* 404 Animation */}
                        <div className="position-relative mb-5">
                            <div style={styles.number404}>404</div>
                            <div className="position-absolute top-50 start-50 translate-middle">
                                <div style={styles.searchIcon}>🔍</div>
                            </div>
                        </div>

                        {/* Message */}
                        <h1 className="display-4 fw-bold text-dark mb-3">Page Not Found</h1>
                        <p className="lead text-muted">
                            The page you're looking for seems to have taken a different engineering path.
                        </p>
                        <p className="text-muted">
                            Don't worry, even the best engineers sometimes take wrong turns. Let's get you back on track!
                        </p>

                        {/* Buttons */}
                        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center mt-4">
                            <button onClick={handleGoHome} style={styles.primaryBtn} className="primary-btn">
                                🏠 Go to Homepage
                            </button>
                            <button onClick={handleGoBack} style={styles.secondaryBtn} className="secondary-btn">
                                ← Go Back
                            </button>
                        </div>
                    </div>
                </main>

                {/* Footer */}
                <footer style={styles.footerBg}>
                    <div className="text-center">
                        <p className="m-0">© 2025 Jawaharlal Nehru Engineering College. All rights reserved.</p>
                    </div>
                </footer>
            </div>
        </>
    );
}
